import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'
import { projectQueryKeys } from '../constants.js'

export const excludeOptions = {
  SUB_FOLDERS: 'SubFolders',
  PROJECTS: 'Projects'
}

export const useGetProjectFolderDetailsQuery = (
  folderId,
  exclude = [],
  options
) => {
  const normalizedExclude = Array.isArray(exclude)
    ? exclude.filter(Boolean)
    : exclude
      ? [exclude]
      : []

  const handleQuery = async () => {
    const params = new URLSearchParams()
    normalizedExclude.forEach((value) => params.append('exclude', value))

    const config = {
      method: 'get',
      params
    }

    const { data } = await api(`/api/v2/projectFolders/${folderId}`, config)

    return data
  }

  return useQuery({
    queryKey: [
      projectQueryKeys.GET_PROJECT_FOLDER_QUERY,
      folderId,
      normalizedExclude
    ],
    queryFn: handleQuery,
    retry: 0,
    enabled: !!folderId,
    ...options
  })
}
